import React, { useContext } from 'react';
import './Auth.css';
import { GoogleLogin } from '@react-oauth/google';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { TextField, Button, Stack } from '@mui/material';
import { AuthContext } from '../shared/context/auth-context';
import axios from 'axios';
import localforage from 'localforage';

const validationSchema = yup.object({
  email: yup.string().email('Ingrese un email valido').required('Se requiere email'),
  password: yup.string().min(8, 'La password tiene que tener al menos 8 caracteres').required('Se requiere email')
});

const Auth = () => {
  const auth = useContext(AuthContext);

  const handleGoogleSuccess = async (credentialResponse) => {
    try {
      // Send the Google credential to your backend
      const response = await axios.post('auth/google', {
        credential: credentialResponse.credential
      });

      // Store user data with session expiration (24 hours)
      const sessionData = {
        user: response.data,
        loginTime: new Date().getTime(),
        expiresIn: 24 * 60 * 60 * 1000 // 24 hours in milliseconds
      };

      localforage.setItem('userSession', sessionData);
      auth.login(response.data);
    } catch (err) {
      console.log('Google authentication failed:', err);

      // Check if it's a 403 Forbidden error (unauthorized email)
      if (err.response && err.response.status === 403) {
        alert('Acceso denegado: Su email no está autorizado para acceder a esta aplicación.');
      } else {
        alert('Error en autenticación con Google');
      }
    }
  };

  const handleGoogleError = () => {
    console.log('Google authentication failed');
    alert('Error en autenticación con Google');
  };

  const formik = useFormik({
    initialValues: {
      email: '',
      password: ''
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      const user = {
        email: values.email,
        password: values.password
      };
      try {
        const response = await axios.post('login', user);

        // Store user data with session expiration (24 hours)
        const sessionData = {
          user: response.data,
          loginTime: new Date().getTime(),
          expiresIn: 24 * 60 * 60 * 1000 // 24 hours in milliseconds
        };

        localforage.setItem('userSession', sessionData);
        auth.login(response.data);
      } catch (err) {
        console.log(err);
        alert('usuario o clave invalidos');
      }
    }
  });
  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-logo">
          <AccessTimeIcon sx={{ color: '#fff', fontSize: 26 }} />
        </div>
        <h2 className="auth-title">Horas</h2>
        <p className="auth-subtitle">Inicia sesión para continuar</p>
        <Stack component="form" noValidate spacing={2.5} onSubmit={formik.handleSubmit}>
          <TextField
            fullWidth
            id="email"
            name="email"
            label="Email"
            variant="outlined"
            value={formik.values.email}
            onChange={formik.handleChange}
            error={formik.touched.email && Boolean(formik.errors.email)}
            helperText={formik.touched.email && formik.errors.email}
          />
          <TextField
            fullWidth
            id="password"
            name="password"
            label="Password"
            type="password"
            variant="outlined"
            value={formik.values.password}
            onChange={formik.handleChange}
            error={formik.touched.password && Boolean(formik.errors.password)}
            helperText={formik.touched.password && formik.errors.password}
          />
          <div className="auth-button-container">
            <Button color="primary" variant="contained" fullWidth size="large" type="submit" sx={{ mb: 2 }}>
              Iniciar Sesión{' '}
            </Button>

            <div className="auth-divider">
              <span>o</span>
            </div>

            <GoogleLogin
              onSuccess={handleGoogleSuccess}
              onError={handleGoogleError}
              size="large"
              width="300"
              text="continue_with"
              locale="es"
            />
          </div>
        </Stack>
      </div>
    </div>
  );
};

export default Auth;
